<app-view-item
  *ngIf="disabled"
  [text]="displayText"
  [borderless]="borderless"
></app-view-item>

<nz-select
  *ngIf="!disabled"
  [nzBorderless]="borderless"
  [(ngModel)]="value"
  nzShowSearch
  nzServerSearch
  (ngModelChange)="onModelChange($event)"
  nzAllowClear="true"
  [nzDropdownMatchSelectWidth]="false"
  [required]="isRequired"
  class="width-100"
  nzDropdownClassName="dropdownSelect"
  (nzOnSearch)="onSearch($event)"
>
  <nz-option
    *ngFor="let item of options"
    [nzValue]="item.Code"
    [nzLabel]="item.Code + ' - ' + item.Name"
  ></nz-option>
</nz-select>
